import { Skeleton } from "@mui/material"
import type { SxProps, Theme } from "@mui/material"

// Holds the name's width while the resource resolves, so the nav row doesn't reflow around it.
const NAME_SKELETON_SX = { width: "8rem" } satisfies SxProps<Theme>

interface ResourceNameProps {
  name?: string
  isLoading: boolean
}

/**
 * The resource's name in a chrome that renders ahead of its data. `ERROR` is terminal, so a failed
 * load falls through to nothing — a skeleton there would shimmer for as long as the page is open.
 */
export default function ResourceName({ name, isLoading }: ResourceNameProps) {
  if (name) {
    return name
  }

  return isLoading ? <Skeleton sx={NAME_SKELETON_SX} /> : null
}
